import type {ComponentProps, ReactNode } from 'react';

import { cn } from './cn';

/**
 * Єдина горизонтальна межа контенту. Не задавай max-width вручну в сторінках.
 * Ширина (`--container-page`) і поле на великих екранах (`--spacing-gutter`) —
 * токени кожного застосунку: пакет спільний, а клієнтові й адмінці потрібна
 * різна щільність.
 */
export function Container({ className, ...props }: ComponentProps<'div'>): ReactNode {
	return <div className={cn('mx-auto w-full max-w-page px-4 sm:px-6 xl:px-gutter', className)} {...props} />;
}
